import React from 'react';
import { Text } from '@erecruit/ui-kit';

interface WorkDescriptionProps {
  description: string;
}

const WorkDescription: React.FC<WorkDescriptionProps> = ({ description }) => {
  return (
    <>
      {description.split('\n').map((line, i) => {
        return <Text key={i}>{line}</Text>;
      })}
    </>
  );
};

export default WorkDescription;
